<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";

const width = ref(0);
const mainRef = ref<HTMLElement>();
let resizeObserver: ResizeObserver | null = null;

const updateMainContentWidth = () => {
  if (mainRef.value) {
    width.value = mainRef.value.clientWidth;
  }
};

onMounted(() => {
  if (mainRef.value) {
    updateMainContentWidth();

    resizeObserver = new ResizeObserver(() => {
      updateMainContentWidth();
    });
    resizeObserver.observe(mainRef.value);
  }
});

onUnmounted(() => {
  if (resizeObserver) {
    resizeObserver.disconnect();
  }
});
</script>

<template>
  <div ref="mainRef">
    <slot v-bind="{ width }"></slot>
  </div>
</template>

<style lang="scss" scoped></style>
